import React from 'react';
import { css } from 'registration-flow-v2';
import * as styles from './preprod-sign-in.css';

const PreprodEnvBanner = (): JSX.Element => (
  <div className={css(styles.envBanner)()}>
    <div className={css(styles.envBannerDot)()} />
    <span className={css(styles.envBannerLabel)()}>PRE-PRODUCTION</span>
    <span className={css(styles.envBannerDesc)()}>
      This is a testing environment — changes here do not affect your live account.
    </span>
  </div>
);

export default PreprodEnvBanner;
